import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: null,
}

export const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setAccessToken: (state , actions) => {
      state.value = actions.payload;
    },
  },
})

export const { setAccessToken } = tokenSlice.actions
export default tokenSlice.reducer